"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.localize = exports.initialize = void 0;
var doLocalize = function (key) { return key.toUpperCase(); };
function initialize(f) {
    if (!f) {
        return;
    }
    doLocalize = f;
}
exports.initialize = initialize;
function localize(key) {
    return doLocalize(key);
}
exports.localize = localize;
